import { Button, ConfigProvider, Flex, Layout, Typography } from 'antd';
import { FileTextOutlined, ShoppingOutlined, ShoppingCartOutlined, UnorderedListOutlined, WalletOutlined } from '@ant-design/icons';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useStoreContext } from '@/shared/lib/store-context';
import { clientPath, ROUTES } from '@/shared/config/routes';
import { LogoutButton } from '@/features/auth/logout';
import { clientTheme } from '@/app/providers/theme';

const { Content, Footer } = Layout;

const TABS = [
  { suffix: '/documents', label: 'Документы', icon: <FileTextOutlined /> },
  { suffix: '/payments', label: 'Оплаты', icon: <WalletOutlined /> },
  { suffix: '/catalog', label: 'Каталог', icon: <ShoppingOutlined /> },
  { suffix: '/cart', label: 'Корзина', icon: <ShoppingCartOutlined /> },
  { suffix: '/order-requests', label: 'Заявки', icon: <UnorderedListOutlined /> },
];

/** §9: кабинет клиента — отдельная тема (14px/36px/без скруглений), нижний таб-бар под телефон. */
export function ClientLayout() {
  const ctx = useStoreContext();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <ConfigProvider theme={clientTheme}>
      <Layout style={{ minHeight: '100vh' }}>
        <Content style={{ padding: 12, paddingBottom: 72 }}>
          {/* Выход обязателен: на общем устройстве следующий клиент должен войти под своей учётной
              записью, а не продолжить в чужом кабинете. */}
          <Flex justify="space-between" align="center" gap={8}>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {ctx.storeName}
            </Typography.Text>
            <Flex align="center">
              <Button type="text" onClick={() => void navigate(ROUTES.stores)}>
                Мои магазины
              </Button>
              <LogoutButton />
            </Flex>
          </Flex>
          <Outlet />
        </Content>
        <Footer
          style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            padding: 0,
            background: '#fff',
            borderTop: '1px solid #d9d9d9',
            zIndex: 10,
          }}
        >
          <Flex>
            {TABS.map((tab) => {
              const path = clientPath(ctx.storeId, tab.suffix);
              const active = location.pathname.startsWith(path);
              return (
                <Flex
                  key={tab.suffix}
                  vertical
                  align="center"
                  justify="center"
                  gap={2}
                  style={{ flex: 1, padding: '8px 0', color: active ? '#1677ff' : undefined, cursor: 'pointer' }}
                  onClick={() => void navigate(path)}
                >
                  {tab.icon}
                  <Typography.Text style={{ fontSize: 11, color: active ? '#1677ff' : undefined }}>{tab.label}</Typography.Text>
                </Flex>
              );
            })}
          </Flex>
        </Footer>
      </Layout>
    </ConfigProvider>
  );
}
